$(document).on('turbolinks:load', function(){
  $('.places-select-field .selected input').prop('disabled', true) 
});
